import { 
    createHouseGroup,
    getHouseGroupList,
    apiBizDelHouseGroup
    } from "@/apis/company/houseGroup.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_house_group_list: 'bizHouseGroupMgt/set_house_group_list',
    set_filter_word: 'bizHouseGroupMgt/set_filter_word',

}

// count state 必須是 Object
const state = {
    houseGroupList: [],
    filter: {
        word: null
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_HOUSE_GROUP_MGT_LIST: (state) => {
        return state.houseGroupList
    },
    GET_BIZ_HOUSE_GROUP_MGT_FILTER_WORD: (state) => {
        return state.filter.word
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizHouseGroupMgtList ( {commit} ) {
        return new Promise((resolve, reject) => {
            getHouseGroupList()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    commit(types.set_house_group_list, res.data.result);
                }
                resolve()
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    createBizHouseGroup ( {commit, dispatch} ) {
        return new Promise((resolve, reject) => {
            createHouseGroup()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    dispatch('getBizHouseGroupMgtList')
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    delBizHouseGroup ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            apiBizDelHouseGroup(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    dispatch('getBizHouseGroupMgtList')
                    dispatch('setAlarmStatus', {status: true,title: '成功刪除房源群組',type: 'success'})
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizHouseGroupFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_house_group_list](state, data){
        state.houseGroupList = data
    },
    [types.set_filter_word](state, data){
        state.filter.word = data
        // state.isDefault = false
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/houseGroupMgt/houseGroupMgt.js